import React, { useMemo } from 'react';
import { useFormikContext } from 'formik';

import { useTranslation } from '@lyearn/i18n';
import { Tabs, TabType } from '@lyearn/ui';
import { useMultiStepContext } from '@/components/MultiStep/context';

import { countSectionErrors, MultiStepSidebarProps } from '../MultiStepSidebar';

const MultiStepTabs: React.FC<MultiStepSidebarProps> = ({
  sections,
  disabledSections,
  className,
}) => {
  const { t } = useTranslation();
  const { errors, touched } = useFormikContext();

  const { activeStepId, setStep } = useMultiStepContext();

  const tabs = useMemo<TabType[]>(
    () =>
      sections.map((section) => ({
        value: section.id,
        label: section.name,
        disabled: disabledSections?.includes(section.id),
        count: countSectionErrors(section, errors, touched),
      })),
    [disabledSections, errors, sections, touched],
  );

  return <Tabs className={className} tabs={tabs} value={activeStepId} onChange={setStep} />;
};

export default MultiStepTabs;
